
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.13.324A1.05 1.05 0 0028.363 0H10.909a1.05 1.05 0 00-.767.324 1.05 1.05 0 00-.324.767v3.273H7.09c-.306 0-.639.074-.997.222a2.601 2.601 0 00-.86.545L1.857 8.505a2.325 2.325 0 00-.384.512 3.139 3.139 0 00-.238.52 2.807 2.807 0 00-.111.63c-.023.268-.037.464-.043.589-.005.124-.005.341 0 .647.006.307.009.506.009.597v5.454a1.05 1.05 0 00-.767.324 1.051 1.051 0 00-.324.767c0 .17.022.322.069.451.044.131.121.236.23.316.108.08.2.145.28.196.08.051.214.086.4.102l.385.035c.068.005.212.005.434 0l.384-.01h1.091c0 1.205.426 2.234 1.278 3.086C5.403 23.574 6.43 24 7.636 24c1.204 0 2.233-.426 3.085-1.28.853-.851 1.279-1.88 1.279-3.084h6.545c0 1.204.426 2.233 1.278 3.085.852.853 1.88 1.279 3.085 1.279s2.233-.426 3.085-1.28c.853-.851 1.279-1.88 1.279-3.084l.383.009c.222.005.367.005.435 0l.383-.035c.188-.016.32-.05.4-.102.08-.05.174-.116.282-.196a.654.654 0 00.23-.316c.046-.13.069-.28.069-.451V1.09c0-.295-.108-.55-.324-.767zM9.17 21.17a2.096 2.096 0 01-1.534.648c-.591 0-1.102-.216-1.534-.648a2.094 2.094 0 01-.648-1.534c0-.59.217-1.102.648-1.533.432-.432.943-.65 1.534-.65.59 0 1.102.218 1.534.65.432.43.648.942.648 1.533s-.216 1.103-.648 1.534zm.648-10.261H3.272v-.51c0-.149.051-.274.154-.376L6.75 6.7a.511.511 0 01.375-.153h2.694v4.363zM24.442 21.17c-.432.432-.943.648-1.534.648-.59 0-1.102-.216-1.535-.648a2.098 2.098 0 01-.647-1.534c0-.59.216-1.102.647-1.533.433-.432.944-.65 1.535-.65s1.102.218 1.534.65c.432.43.648.942.648 1.533s-.216 1.103-.648 1.534z","fill":"#BDBDBD","fill-rule":"evenodd"}})])
          )
        }
      }
    